import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      height: '100%',
    },
    dialogContent: {
      flex: '1 1 0',
    },
  })
);
